// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__lKT24","modal__close":"style_modal__close__d37mx"};